import { render, staticRenderFns } from "./HotSale.vue?vue&type=template&id=08e20415&scoped=true"
import script from "./HotSale.vue?vue&type=script&lang=js"
export * from "./HotSale.vue?vue&type=script&lang=js"
import style0 from "./HotSale.vue?vue&type=style&index=0&id=08e20415&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e20415",
  null
  
)

export default component.exports